import cn from 'classnames';

import { PlaybackState } from 'components/Player';
import { SizeProp } from 'types';
import styles from './PlaybackButton.module.scss';
import PlaybackIcon from './PlaybackIcon';

export interface PlaybackButtonProps {
  className?: string;
  disabled?: boolean;
  iconClassName?: string;
  loading?: boolean;
  size?: SizeProp;
  status: PlaybackState;
}

const PlaybackButton: React.FC<PlaybackButtonProps> = ({
  className,
  disabled,
  iconClassName,
  loading,
  size = 'lg',
  status,
}) => (
  <div
    className={cn(
      styles.playbackButton,
      {
        [styles[`playbackButton__${size}`]]: !!size,
        [styles.playbackButton__disabled]: disabled,
      },
      className,
    )}
  >
    <PlaybackIcon className={iconClassName} {...{ loading, status }} />
  </div>
);

export default PlaybackButton;
